import PropTypes from 'prop-types';
import { Box, Button, Stack, Typography } from '@mui/material';

import Iconify from '../../../components/iconify';

WorkspaceEmptyState.propTypes = {
  onAddRecording: PropTypes.func.isRequired,
};

/** Shown when the workspace holds nothing with a time span to lay out. */
export default function WorkspaceEmptyState({ onAddRecording }) {
  return (
    <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Stack alignItems="center" spacing={2}>
        <Iconify icon="eva:film-outline" width={48} sx={{ color: 'text.disabled' }} />
        <Typography variant="h6" color="text.secondary">No recordings yet</Typography>
        <Typography variant="body2" color="text.disabled">Add recordings to start building your workspace</Typography>
        <Button variant="contained" onClick={onAddRecording}>Add Recording</Button>
      </Stack>
    </Box>
  );
}
